import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MaintenanceTypeApi } from '@api/maintenanceType.api';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime, tap } from 'rxjs/operators';
import english from '../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../main/maintenances/i18n/pt.json';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return MaintenanceTypeSearchComponent; }),
    multi: true
};
var MaintenanceTypeSearchComponent = /** @class */ (function () {
    function MaintenanceTypeSearchComponent(fuseTranslationLoaderService, maintenanceTypeApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.maintenanceTypeApi = maintenanceTypeApi;
        this.required = false;
        this.showAllAsAnOption = false;
        this.floatLabel = true;
        this.disabled = false;
        this.appearance = 'outline';
        this.maintenanceTypes = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        if (this.required) {
            this.inputValue.setValidators(ValidateAutocomplete);
        }
    }
    MaintenanceTypeSearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.disabled) {
            this.inputValue.disable();
        }
        this.inputValue.valueChanges
            .pipe(tap(function (value) {
            if (_this.showAllAsAnOption && (value === 'allOptions')) {
                _this.hasSelectedMaintenanceType = true;
            }
        }), debounceTime(500))
            .subscribe(function (value) {
            if (value) {
                _this.searchMaintenanceTypes(value);
            }
        });
    };
    MaintenanceTypeSearchComponent.prototype.searchMaintenanceTypes = function (value) {
        var _this = this;
        this.loading = true;
        this.maintenanceTypeApi.search({
            name_contains: value,
            archived: false
        }).subscribe(function (result) {
            _this.loading = false;
            _this.maintenanceTypes = result.items;
        });
    };
    MaintenanceTypeSearchComponent.prototype.writeValue = function (maintenanceTypeId) {
        var _this = this;
        if (maintenanceTypeId) {
            this.maintenanceTypeApi.searchOne(maintenanceTypeId).then(function (maintenanceType) {
                _this.selectedMaintenanceType = maintenanceType;
                _this.hasSelectedMaintenanceType = true;
                _this.inputValue.setErrors(null);
                _this.inputValue.setValue(maintenanceTypeId);
            });
        }
        else if (!maintenanceTypeId && this.showAllAsAnOption) {
            this.inputValue.setValue('allOptions');
        }
        else {
            this.deselectMaintenanceType();
        }
    };
    MaintenanceTypeSearchComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    MaintenanceTypeSearchComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    MaintenanceTypeSearchComponent.prototype.setSelectedMaintenanceType = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.onChange(this.inputValue.value);
            this.selectedMaintenanceType = this.maintenanceTypes.find(function (maintenanceType) { return maintenanceType.id === _this.inputValue.value; });
            this.hasSelectedMaintenanceType = true;
            this.inputValue.setErrors(null);
        }
    };
    MaintenanceTypeSearchComponent.prototype.deselectMaintenanceType = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.selectedMaintenanceType = null;
        this.hasSelectedMaintenanceType = false;
        this.inputValue.setErrors(null);
    };
    return MaintenanceTypeSearchComponent;
}());
export { MaintenanceTypeSearchComponent };
